import { render } from "./EnergyGuideUpload.vue?vue&type=template&id=4187f4ba"
import script from "./EnergyGuideUpload.vue?vue&type=script&lang=js"
export * from "./EnergyGuideUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__